import React, { FunctionComponent, memo, ReactNode } from 'react'

import styled from 'styled-components'
import { SpaceProps, space } from 'styled-system'

import { InfoTooltip } from '@/atoms/info-tooltip'
import { Flex } from '@/atoms/layout'
import { Label } from '@/atoms/typography'
import { Space } from '@/styles'

interface Props {
  id: string
  label: ReactNode
  tooltip?: string
}

const FieldLabel: FunctionComponent<Props & SpaceProps> = ({ id, label, tooltip, ...fieldProps }: Props & SpaceProps) => (
  <Flex {...fieldProps}>
    <StyledLabel htmlFor={id} $withTooltip={!!tooltip}>
      {label}
    </StyledLabel>
    {tooltip && <InfoTooltip tooltipText={tooltip} pl={Space.S8} />}
  </Flex>
)

const StyledLabel = styled(Label)<{ htmlFor: string; $withTooltip: boolean }>`
  cursor: pointer;
  width: ${({ $withTooltip }) => ($withTooltip ? 'auto' : '100%')};

  ${space}
`

FieldLabel.displayName = 'FieldLabel'

export default memo(FieldLabel)
